import React, { FC } from 'react'

import { Page, PageContent } from 'common'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import {
  EntityButtonContainer,
  EntityMenuContainer,
  HeaderSkeletonContainer,
} from '../styles/EntityMenu.styles'

export const EntityMenuSkeleton: FC = () => (
  <Page>
    <HeaderSkeletonContainer>
      <Skeleton width="1.5rem" height="1.5rem" style={{ borderRadius: '50%' }} />
      <Skeleton width="7.165rem" height="1.5rem" />
      <Skeleton width="1.5rem" height="1.5rem" style={{ borderRadius: '50%' }} />
    </HeaderSkeletonContainer>
    <PageContent>
      <EntityMenuContainer>
        <EntityButtonContainer>
          <Skeleton width="100%" height="3.765rem" />
        </EntityButtonContainer>
        <EntityButtonContainer>
          <Skeleton width="100%" height="3.765rem" />
        </EntityButtonContainer>
        <EntityButtonContainer>
          <Skeleton width="100%" height="3.765rem" />
        </EntityButtonContainer>
        <EntityButtonContainer>
          <Skeleton width="100%" height="3.765rem" />
        </EntityButtonContainer>
      </EntityMenuContainer>
    </PageContent>
  </Page>
)
